/**
 * Public permalink: /sport/:gameId/tournament/:tournamentId – tournament view. Viewable without login.
 */

import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getTournamentPublicDetails } from '../../api/readApi';
import { getGameById } from '../../constants/games';
import PublicLayout from '../../components/PublicLayout';
import { useAuth } from '../../contexts/AuthContext';
import '../PublicPages.css';

export default function PublicTournamentPage() {
  const { gameId, tournamentId } = useParams();
  const { currentUser } = useAuth();
  const game = getGameById(gameId);
  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tournamentId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    getTournamentPublicDetails(tournamentId)
      .then((data) => {
        if (cancelled) return;
        setTournament(data || null);
      })
      .catch(() => {
        if (!cancelled) setTournament(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [tournamentId]);

  if (!game) {
    return (
      <PublicLayout>
        <p>Sport not found.</p>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout title={tournament?.name ? `${game.icon} ${tournament.name}` : `${game.icon} Tournament`}>
      <nav className="public-breadcrumb">
        <Link to={`/sport/${gameId}`} className="public-link">← {game.name}</Link>
      </nav>
      <div className="public-card card-ui">
        {loading ? (
          <p className="public-loading">Loading…</p>
        ) : !tournament ? (
          <p className="public-no-data">Tournament not found.</p>
        ) : (
          <>
            <h2 style={{ margin: '0 0 12px' }}>{tournament.name || 'Tournament'}</h2>
            <p className="public-desc">{tournament.description || ''}</p>
            <nav className="public-nav-links">
              <Link to={`/sport/${gameId}/tournament/${tournamentId}/match`} className="public-link">
                Matches
              </Link>
            </nav>
            {currentUser && (
              <p className="public-logged-in">
                You are logged in. Open tournament dashboard from the app for full access.
              </p>
            )}
          </>
        )}
      </div>
    </PublicLayout>
  );
}
